import { FC } from 'react';

import Head from 'next/head';

import { useSiteSettings } from 'hooks/useSiteSettings';

export const StoreSEO: FC = () => {
  const { storeSettings } = useSiteSettings();

  return (
    <Head>
      <meta name="author" content={storeSettings?.name || 'Pra Vendas'} />
      <meta property="og:type" content="article" />
      <meta property="og:locale" content="pt_BR" />

      <meta name="image" content={storeSettings?.logo || ''} />
      <meta property="og:image" content={storeSettings?.logo || ''} />
      <meta property="og:image:width" content="500" />
      <meta property="og:image:height" content="500" />

      <meta name="description" content={storeSettings?.description || ''} />
      <meta
        property="og:description"
        content={storeSettings?.description || ''}
      />

      <meta property="og:title" content={storeSettings?.name || ''} />
      <meta property="og:site_name" content={storeSettings?.name || ''} />

      <meta name="url" content={storeSettings?.url} />
      <meta property="og:url" content={storeSettings?.url} />

      <title>{storeSettings?.title || 'Loja do Pra Vendas'}</title>

      <link
        rel="shortcut icon"
        type="image/x-icon"
        href={storeSettings?.favicon || './pravendas-favicon.png'}
      />
    </Head>
  );
};
